import { injectIntl, IntlShape } from 'react-intl';
import { Create } from '@material-ui/icons';
import { get, isEmpty } from 'lodash';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/messages';
import { translate } from 'containers/services/translate';
import {
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from '@material-ui/core';
import { numberWithCommas } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import Dialog from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RiskAmount/Dialog';
import { RISK_NAME } from 'containers/CourtManagerLegalProceedings/Provision/constants';
import { JUDICIARY_TYPE } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { enableRemainingJudgement } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/Recap/utils';
import { REGULATION_AMOUNTS } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/data-structure';
import {
  getExecutionByVictim,
  isLatestRegulationExistBawaba,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RiskAmount/utils';
import { VictimType } from 'typings/globalTypes';
export interface BeneficiaryProps {
  intl: IntlShape;
  setRiskRecap: Function;
  riskRecap: any;
  rcCorporeal: any;
  beneficiary: any;
  closeDialog: Function;
  openDialogValidation: any;
  handleDialogValidation: Function;
  dahirAmountByVictimKey: any;
  victim: VictimType;
  regulations: any;
  listings: any;
  corpoRegulations: any;
  isBasicManagementRegulation?: boolean;
}

export const Beneficiary: React.FC<BeneficiaryProps> = ({
  rcCorporeal,
  riskRecap,
  setRiskRecap,
  beneficiary,
  openDialogValidation,
  handleDialogValidation,
  dahirAmountByVictimKey,
  ...props
}): JSX.Element => {
  const hasRemainingAmount = enableRemainingJudgement(
    get(rcCorporeal, 'regulationInfo.natureCode'),
  );
  const showArrestAmount =
    props.isBasicManagementRegulation &&
    get(rcCorporeal, 'regulationInfo.isAppeal');

  const handleChange = (beneficiary: any, type?: any) => (
    event: React.ChangeEvent<{ name: string; value: any }>,
  ) => {
    const risks = [...riskRecap] as any;
    const currentType =
      risks.find((risk: any) => risk.riskName === RISK_NAME.CORPOREAL) || {};
    const currentVictim =
      get(currentType, 'data', []).find(
        (item: any) => item.id === beneficiary.victimId,
      ) || {};
    const currentBeneficiary =
      get(currentVictim, 'beneficiaries', []).find(
        (item: any) => item.id === beneficiary.id,
      ) || {};
    if (
      !isEmpty(currentType) &&
      !isEmpty(currentVictim) &&
      !isEmpty(currentBeneficiary)
    ) {
      const index = risks.indexOf(currentType);
      const victimIndex = get(currentType, 'data', []).indexOf(currentVictim);
      const beneficiaryIndex = get(currentVictim, 'beneficiaries', []).indexOf(
        currentBeneficiary,
      );
      const regulationAmount = get(
        risks[index].data[victimIndex].beneficiaries[beneficiaryIndex],
        type,
        {},
      );
      switch (event.target.name) {
        case REGULATION_AMOUNTS.EXECUTION_PROV_AMOUNT:
          const beneficiary =
            risks[index].data[victimIndex].beneficiaries[beneficiaryIndex];
          beneficiary[event.target.name] = numberWithCommas(event.target.value);
          break;
        default:
          regulationAmount[event.target.name] = event.target.value;

          break;
      }
      return setRiskRecap(risks);
    }
  };
  return (
    <>
      <Grid container direction="row" className="beneficiary">
        <div className="beneficiary-name">{`${beneficiary.lastName} ${beneficiary.firstName}`}</div>
        <Grid container direction="row" spacing={2}>
          <Grid item xs={3}>
            <TextField
              fullWidth
              label={translate(messages.beneficiaryCompensationAmount, props)}
              value={numberWithCommas(
                String(get(beneficiary, 'jomBeneficiary.judgementAmount', 0)),
              )}
              InputProps={{
                endAdornment: (
                  <>
                    <InputAdornment position="end">
                      {
                        <IconButton
                          id={'update-beneficiary-icon'}
                          name={'update-beneficiary-icon'}
                          onClick={handleDialogValidation(
                            JUDICIARY_TYPE.FIRST_INSTANCE,
                            beneficiary.id,
                          )}
                          edge="end"
                        >
                          <Create />
                        </IconButton>
                      }
                    </InputAdornment>
                  </>
                ),
              }}
              disabled={true}
            />
          </Grid>
          {(!isEmpty(get(beneficiary, 'appealBeneficiary')) ||
            showArrestAmount) && (
            <Grid item xs={3}>
              <TextField
                fullWidth
                label={translate(
                  messages.beneficiaryAppealCompensationAmount,
                  props,
                )}
                value={numberWithCommas(
                  String(
                    get(beneficiary, 'appealBeneficiary.judgementAmount', 0),
                  ),
                )}
                InputProps={{
                  endAdornment: (
                    <>
                      <InputAdornment position="end">
                        {
                          <IconButton
                            id={'update-beneficiary-icon'}
                            name={'update-beneficiary-icon'}
                            onClick={handleDialogValidation(
                              JUDICIARY_TYPE.APPEAL,
                              beneficiary.id,
                            )}
                            edge="end"
                          >
                            <Create />
                          </IconButton>
                        }
                      </InputAdornment>
                    </>
                  ),
                }}
                disabled={true}
              />
            </Grid>
          )}

          {featureService.hasFeature(FEATURES.REGULATION_V2) && (
            <Grid item xs={3}>
              <TextField
                fullWidth
                label={translate(
                  messages.beneficiaryCalculatedCompensationAmount,
                  props,
                )}
                value={
                  get(dahirAmountByVictimKey[get(props.victim, 'victimKey')], [
                    [
                      `${beneficiary?.firstName} ${beneficiary?.lastName}-${beneficiary?.beneficiaryType}`,
                    ] as any,
                    'totalAmount',
                  ])
                    ? numberWithCommas(
                        String(
                          get(
                            dahirAmountByVictimKey[
                              get(props.victim, 'victimKey')
                            ],
                            [
                              [
                                `${beneficiary?.firstName} ${beneficiary?.lastName}-${beneficiary?.beneficiaryType}`,
                              ] as any,
                              'totalAmount',
                            ],
                            0,
                          ),
                        ),
                      )
                    : numberWithCommas(
                        String(
                          get(
                            dahirAmountByVictimKey[
                              get(props.victim, 'victimKey')
                            ],
                            [
                              [
                                `nextOfKinKey-${beneficiary?.nextOfKinKey}`,
                              ] as any,
                              'totalAmount',
                            ],
                            0,
                          ),
                        ),
                      )
                }
                disabled={true}
              />
            </Grid>
          )}
          {hasRemainingAmount && (
            <Grid item xs={3}>
              <FormControl fullWidth>
                <TextField
                  fullWidth
                  label={translate(messages.provisionalExecution, props)}
                  name={REGULATION_AMOUNTS.EXECUTION_PROV_AMOUNT}
                  id={REGULATION_AMOUNTS.EXECUTION_PROV_AMOUNT}
                  disabled={isLatestRegulationExistBawaba(
                    props.corpoRegulations,
                    props.regulations,
                    get(props.listings, 'PaymentStatus', []),
                    props.victim,
                  )}
                  value={get(
                    beneficiary,
                    'manualExecutionProvAmount',
                    get(
                      getExecutionByVictim(
                        props.regulations,
                        props.victim,
                        get(props.listings, 'PaymentStatus', []),
                        beneficiary,
                      ),
                      'executionProvAmount',
                    ),
                  )}
                  onChange={handleChange(beneficiary)}
                />
              </FormControl>
            </Grid>
          )}
        </Grid>
      </Grid>

      <Dialog
        open={
          get(
            openDialogValidation[beneficiary?.id],
            'activateJudgement',
            false,
          ) ||
          get(openDialogValidation[beneficiary?.id], 'activateAppeal', false)
        }
        handleClose={() => props.closeDialog(beneficiary.id)}
        handleValidate={() => props.closeDialog(beneficiary.id)}
        item={beneficiary}
        riskRecap={riskRecap}
        setRiskRecap={setRiskRecap}
        openDialogValidation={openDialogValidation}
        handleChange={handleChange}
        rcCorporeal={rcCorporeal}
        title={translate(messages.updateBeneficiaryDialogTitle, props, {
          type:
            get(openDialogValidation[beneficiary?.id], 'type') ===
            JUDICIARY_TYPE.APPEAL
              ? translate(messages.appeal, props)
              : translate(messages.judgement, props),
        })}
        disabled={
          props.isBasicManagementRegulation
            ? get(openDialogValidation[beneficiary?.id], 'type') ===
              JUDICIARY_TYPE.APPEAL
              ? isEmpty(
                  get(beneficiary, 'appealBeneficiary.judgementAmount', ''),
                )
              : isEmpty(get(beneficiary, 'jomBeneficiary.judgementAmount', ''))
            : get(openDialogValidation[beneficiary?.id], 'type') ===
              JUDICIARY_TYPE.APPEAL
            ? isEmpty(get(beneficiary, 'appealBeneficiary.appealReason', ''))
            : isEmpty(get(beneficiary, 'jomBeneficiary.judgementReason', ''))
        }
        isBasicManagementRegulation={props.isBasicManagementRegulation}
      />
    </>
  );
};

export default injectIntl(Beneficiary);
